import { ref } from 'vue'
import { getUseRuleConfig, updateUseRuleConfig } from '@/apis/systemSafeMange'
import { useOrgInfoStore } from '@/stores/modules/orgInfo'

export function useRuleConfig() {
  // 系统安全配置
  const useRuleConfigData = ref<any>({})
  const { sysInfo } = useOrgInfoStore()
  async function getConfig() {
    const res = await getUseRuleConfig()
    useRuleConfigData.value = res
    sysInfo.config = res
    return res
  }

  function updateConfig() {
    updateUseRuleConfig(useRuleConfigData.value).then(() => {
      ElMessage.success('修改成功')
      sysInfo.config = { ...sysInfo.config, ...useRuleConfigData.value }
    })
  }
  function setData(data: Recordable) {
    useRuleConfigData.value = {
      ...useRuleConfigData.value,
      ...data
    }
    console.log(useRuleConfigData, 'useRuleConfigData')
  }

  return { getConfig, updateConfig, setData }
}
